import { createSlice } from '@reduxjs/toolkit';
import { resetStore } from '../../Actions';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
// import { fireApi } from 'src/utils/FireApi';
import { CallCenterApi } from '../../../utils/Apis';

const initialState = {
  call_center: null,
  call_view: null,
  employementType: null,
  SubEmployementType: null
};

const CallCenterSlice = createSlice({
  name: 'CallCenter',
  initialState,
  reducers: {
    setCallCenter(state, action) {
      state.call_center = action.payload;
    },
    setCallView(state, action) {
      state.call_view = action.payload;
    },
    setEmployementType(state, action) {
      state.employementType = action.payload;
    },
    setSubEmployementType(state, action) {
      state.SubEmployementType = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Call Center
export const getCallCenterList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CallCenterApi?.callCenterGrid,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCallCenter(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCallCenter(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Call Center failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Call Center exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// employement type list
export const getEmployementTypeList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CallCenterApi?.employementGrid,
      method: 'post',
      payload: data
    });
    console.log('res employement type', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setEmployementType(res?.data?.data ? res?.data?.data?.empTypes : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setEmployementType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Call Center failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Call Center exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// sub employement type list
export const getSubEmployementTypeList = (data) => async (dispatch) => {
  dispatch(setSubEmployementType(null));
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CallCenterApi?.SubemployementGrid,
      method: 'post',
      payload: data
    });
    // console.log('res sub employement type', res);
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setSubEmployementType(res?.data?.data ? res?.data?.data?.subEmpTypes : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setSubEmployementType(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ sub employement type failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 sub employement type exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Call Center View
export const getCallCenterView = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: CallCenterApi?.callCenterView,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCallView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCallView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Call Center View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Call Center View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setCallCenter, setCallView, setEmployementType, setSubEmployementType } =
  CallCenterSlice.actions;
export default CallCenterSlice.reducer;
